import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ShowcaseEntity } from '../../domain/entities/ShowcaseEntity'
export class ShowcaseModel extends ShowcaseEntity {
  constructor(dataDto: ShowcaseEntity) {
    super()
    mapEntityProperties<ShowcaseEntity>(this, dataDto, {
      exclude: ['channel'],
      map: {
        channel: {
          name: dataDto.channelName,
          id: dataDto.channel?.id
        }
      }
    })
  }
}
